import http from './http';

export function coinMain({ chainNum }, config = {}) {
  return http.postJson('/coin/main', { chainNum }, config);
}

export function transactionListV2({ chainNum, contractAddress = '0x', address, type = null, pageNum = 1 } = {}, config = {}) {
  return http.postJson('/transaction/list/v2', {
    chainNum,
    contractAddress,
    address,
    type,
    pageNum
  }, config);
}

export function transactionFee({ address, chainNum } = {}, config = {}) {
  return http.postJson('/transaction/fee', { address, chainNum }, config);
}

export function transactionUtxo({ address, chainNum } = {}, config = {}) {
  return http.postJson('/transaction/utxo', { address, chainNum }, config);
}

export function transactionUpdateRecord({ chainNum, fromAddress, toAddress, hash, amount, contractAddress } = {}, config = {}) {
  return http.postJson('/transaction/update/record', {
    chainNum,
    fromAddress,
    toAddress,
    hash,
    amount,
    contractAddress
  }, config);
}

export function nftBalanceList({ address, chainNum } = {}, config = {}) {
  return http.postJson('/nft/balance/list', {
    address,
    chainNum: String(chainNum || '')
  }, config);
}

export function nftHotList({ address, chainNum } = {}, config = {}) {
  return http.postJson('/nft/hot/list', {
    address,
    chainNum: String(chainNum || '')
  }, config);
}

export function nftAdd({ address, chainNum, contractAddress } = {}, config = {}) {
  return http.postJson('/nft/add', {
    address,
    chainNum: String(chainNum || ''),
    contractAddress
  }, config);
}

export function nftList({ address, chainNum, contractAddress, protocolType } = {}, config = {}) {
  return http.postJson('/nft/list', {
    address,
    chainNum: String(chainNum || ''),
    contractAddress,
    protocolType
  }, config);
}

export function pcCardAssetList({ address } = {}, config = {}) {
  return http.postJson('/pc/card/asset/list', { address }, config);
}

export function pcCardLogLast({ address } = {}, config = {}) {
  return http.postJson('/pc/card/log/last', { address }, config);
}

export function pcCardAssetChargeInfo({ address }) {
  return http.postJson('/pc/card/asset/charge/info', { address });
}

export function pcCardAssetWithdrawInfo({ address }) {
  return http.postJson('/pc/card/asset/withdraw/info', { address });
}

export function pcCardAssetWithdraw({ address, amount, symbol, symbolType, addressTo }) {
  return http.postJson('/pc/card/asset/withdraw', {
    address,
    amount,
    symbol,
    symbolType,
    addressTo
  });
}

export function pcCardAssetTransfer(
  { toUserId, symbol, amount, payPwd, emailCode },
  config = {},
) {
  return http.postJson('/pc/card/asset/transfer', {
    toUserId,
    symbol,
    amount,
    payPwd,
    emailCode
  }, config);
}

export function pcCardAssetLogList({ address, pageNum = 1, pageSize = 10 } = {}) {
  return http.postJson('/pc/card/asset/log/list', {
    address,
    pageNum,
    pageSize
  });
}

export function ptInfo({ address } = {}, config = {}) {
  return http.postJson('/pt/info', { address }, config);
}

export function ptBindParent({ address, invitationCode }) {
  return http.postJson('/pt/bind/parent', {
    address,
    invitationCode
  });
}

export function refDoc({ address, lang } = {}, config = {}) {
  return http.postJson('/ref/doc', {
    address,
    lang
  }, config);
}

export function refOverview({ address, lang } = {}, config = {}) {
  return http.postJson('/ref/overview', {
    address,
    lang
  }, config);
}

export function refRewardClaim({ address, lang, coinId } = {}, config = {}) {
  return http.postJson('/ref/reward/claim', {
    address,
    lang,
    coinId
  }, config);
}

export function refRewardDetail({ id } = {}, config = {}) {
  return http.postJson('/ref/reward/detail', { id }, config);
}

export function refRewardList({ pageNum = 1, pageSize = 20, type, lastDays } = {}, config = {}) {
  const payload = {
    pageNum,
    pageSize,
    lastDays,
    category: Number(type)
  };

  return http.postJson('/ref/reward/list', payload, config);
}

export function refFriendList({ listType = 1, pageNum = 1, pageSize = 20 } = {}, config = {}) {
  return http.postJson('/ref/friend/list', {
    listType: Number(listType) === 2 ? 2 : 1,
    pageNum,
    pageSize
  }, config);
}

export function ptCheckinSubmit({ address }) {
  return http.postJson('/pt/checkin/submit', {
    address
  });
}

export function ptAssetLogList({ address, pageNum = 1, pageSize = 20 } = {}, config = {}) {
  return http.postJson('/pt/asset/log/list', {
    address,
    pageNum,
    pageSize
  }, config);
}

export function userDirectPushList({ address, pageNum = 1, pageSize = 999 } = {}, config = {}) {
  return http.postJson('/user/directPush/list', {
    address,
    pageNum,
    pageSize
  }, config);
}
export function chainHotList() {
  return http.postJson('/chain/hot/list', {});
}

export function chainNodeList({ chainNum }) {
  return http.postJson('/chain/node/list', { chainNum });
}

export function coinHotList({ chainNum } = {}, config = {}) {
  return http.postJson('/coin/hot/list', { chainNum }, config);
}

export function coinInfoV1({ contractAddress, chainNum } = {}, config = {}) {
  return http.postJson('/coin/info/v1', {
    address: contractAddress,
    chainNum
  }, config);
}

export function coinAddV1({ contractAddress, symbol, decimal, chainNum } = {}, config = {}) {
  return http.postJson('/coin/add/v1', {
    address: contractAddress,
    symbol,
    decimal,
    chainNum
  }, config);
}
